<template>
    <el-form status-icon :model="psForm" :rules="rulesPS" ref="psForm" @submit.native.prevent="enter"
             class="demo-ruleForm">
        <div>
            <el-row>
                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                    <el-form-item label='PS Adı'
                                  prop="psAdi" class="margin-top-20">:
                        <el-input
                                v-model="psForm.psAdi"
                                placeholder='PS Adı Giriniz'></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </div>
        <el-row class="col-p">
            <el-form-item>
                <el-button size="small" v-on:click="psTanimla('psForm')"
                           type="primary">
                    Tanımla
                </el-button>
            </el-form-item>
        </el-row>
    </el-form>

</template>

<script>
    import EventBus from '@/components/event-bus'

    import psService from '../../../../WSProvider/OpsiyonService'
    import notification from '../../../../notification'
    export default {
        name: "PSEkle",
        mounted() {
            this.getPSListesi();
        },
        data() {
            return {
                psListesi: [],
                psForm: {
                    psAdi: '',
                },
                rulesPS: {
                    psAdi: [{
                        required: true,
                        message: "Lütfen Başlık Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            getPSListesi() {
                psService.psList(1, "", "").then((response) => {
                    if (response.status === 200) {
                        this.psListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            psTanimla(formName) {
                var dizi = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        psService.psTanimlama(this.psForm.psAdi).then((response) => {
                            if (response.status === 200) {
                                this.psListesi.push(response.data);
                                this.psListesi.forEach(function (value) {
                                    dizi.push({
                                        secenekAdi: value.psAdi,
                                        secenekKodu: value.psKodu,
                                    })
                                });
                                EventBus.$emit("opsiyonList", true)
                                // this.$store.commit('changeOpsiyonList', dizi);
                                notification.Status('success', this, 'PS başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir ps zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>